import { tuple } from '../../utils/utils'

export const collectionTypes = tuple([
  'highlights',
  'schedule',
  'episodes',
  'bonus',
  'carousel',
])

export const tabSupportedCollectionsTypes = tuple([
  'episodes',
  'bonus',
])

export type CollectionType = (typeof collectionTypes)[number]
export const isCollectionType = (x: any): x is CollectionType =>
  collectionTypes.includes(x)

export const isTabSupportedCollection = (x: any): x is CollectionType =>
  tabSupportedCollectionsTypes.includes(x)
